const STORAGE_KEY = "ics.projectWorkspace";

export const PROJECT_TAB_KEYS = [
  "overview",
  "clients",
  "documents",
  "client_contacts",
  "properties",
  "bank_project_accounts",
  "tasks",
  "appointments",
  "accounting",
];

export function getProjectWorkspace() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.projectId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function rememberProjectWorkspace({ projectId, tab, title } = {}) {
  const prev = getProjectWorkspace() || {};
  const next = {
    projectId: String(projectId || prev.projectId || ""),
    tab: tab || prev.tab || "overview",
    title: title || prev.title || "",
  };
  if (!next.projectId) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (_) {
    /* ignore quota / private mode */
  }
}

export function tabIndexFromSearch(tabKeys, search) {
  const qs =
    search != null
      ? search
      : typeof window !== "undefined"
        ? window.location.search
        : "";
  const params = new URLSearchParams(qs.startsWith("?") ? qs.slice(1) : qs);
  const idx = tabKeys.indexOf(params.get("tab"));
  return idx >= 0 ? idx : 0;
}

export function replaceTabInUrl(tabKeys, index) {
  if (typeof window === "undefined") return;
  const key = tabKeys[index] || tabKeys[0];
  const url = new URL(window.location.href);
  if (!key || key === tabKeys[0]) url.searchParams.delete("tab");
  else url.searchParams.set("tab", key);
  const qs = url.searchParams.toString();
  window.history.replaceState(null, "", url.pathname + (qs ? `?${qs}` : "") + url.hash);
}

export function projectIdFromPath(pathname) {
  const path = pathname || (typeof window !== "undefined" ? window.location.pathname : "");
  const parts = path.split("/").filter(Boolean);
  const idx = parts.indexOf("project");
  if (idx === -1) return null;
  const id = parts[idx + 1] || null;
  return id ? decodeURIComponent(id) : null;
}
